<template>
  <b-row>
    <b-col class="px-0">
      <div
        class="close_advance_filter"
        v-b-tooltip.hover
        :title="$lang.close"
        @click="closeAdvance"
      >
        ×
      </div>
    </b-col>
    <b-col cols="12" md="12">
      <b-row v-for="(header, index) in headers" :key="index">
        <advanceFilterCheckboxSingleSelect
          ref="SingleSelect"
          v-if="header.type == `checkbox_singleselect`"
          :header="header"
          :value="header.selected"
          @selected="selected"
        />
        <advanceFilterCheckboxMultiselect
          :value="header.selected"
          ref="Multiselect"
          v-if="header.type == `checkbox_multiselect`"
          :header="header"
          @selected="selected"
        />
        <advanceFilterText
          ref="FilterText"
          :value="header.selected"
          v-if="header.type == `text`"
          :header="header"
          @selected="selected"
        />
        <dateTime
          ref="dateTime"
          v-if="
            header.advanced &&
            ['date', 'datetime', 'time', 'year', 'yearmonth', 'month'].includes(
              header.type
            )
          "
          :value="header.selected"
          :header="header"
          @dateSelected="dateSelected"
        />
        <advanceFilterNumber
          ref="FilterNumber"
          v-if="header.advanced && header.type === 'number'"
          :value="header.selected"
          :header="header"
          @numberSelected="dateSelected"
        />
      </b-row>
    </b-col>
  </b-row>
</template>
<script>
import advanceFilterCheckboxSingleSelect from "./advanceFilterCheckboxSingleSelect";
import advanceFilterCheckboxMultiselect from "./advanceFilterCheckboxMultiselect";
import advanceFilterText from "./advanceFilterText";
import advanceFilterNumber from "./advanceFilterNumber";
import dateTime from "./dateTime";

export default {
  components: {
    advanceFilterCheckboxSingleSelect,
    advanceFilterCheckboxMultiselect,
    advanceFilterText,
    advanceFilterNumber,
    dateTime,
  },
  props: {
    headers: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      params: {},
    };
  },
  methods: {
    closeAdvance() {
      this.$emit("closeAdvanceFilter");
    },
    deleteAll() {
      this.$refs.dateTime && this.$refs.dateTime.map((x) => (x.result = []));
      this.$refs.FilterText &&
        this.$refs.FilterText.map((x) => (x.searchTextValue = ""));
      this.$refs.Multiselect &&
        this.$refs.Multiselect.map((x) => (x.result = []));
      this.$refs.SingleSelect &&
        this.$refs.SingleSelect.map((x) => (x.result = ""));
      this.$refs.dateTime && this.$refs.dateTime.map((x) => x.clearAllData());
    },
    expandAll() {
      this.$refs.dateTime &&
        this.$refs.dateTime.map((x) => (x.expanded = false));
      this.$refs.FilterNumber &&
        this.$refs.FilterNumber.map((x) => (x.expanded = false));
      this.$refs.FilterText &&
        this.$refs.FilterText.map((x) => (x.expanded = false));
      this.$refs.Multiselect &&
        this.$refs.Multiselect.map((x) => (x.expanded = false));
      this.$refs.SingleSelect &&
        this.$refs.SingleSelect.map((x) => (x.expanded = false));
    },
    allFilterRemove() {
      this.$refs.Multiselect &&
        this.$refs.Multiselect.map((x) => x.deleteValue());
      this.$refs.SingleSelect &&
        this.$refs.SingleSelect.map((x) => x.deleteValue());
      this.$refs.FilterText &&
        this.$refs.FilterText.map((x) => x.deleteValue());
      this.$refs.dateTime && this.$refs.dateTime.map((x) => x.deleteValue());
    },
    dateSelected(key, type, value_from, value_to) {
      this.$emit("getFilterDate", key, type, value_from, value_to);
    },
    selected(value, key) {
      this.$emit("getFilterItems", value, key);
    },
  },
};
</script>

<style lang="scss" scoped>
.close_advance_filter {
  background: #cf2f2f;
  border-radius: 5px;
  height: 35px;
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -ms-flex-line-pack: center;
  align-content: center;
  font-size: 27px;
  color: white;
  margin-bottom: 10px;
  cursor: pointer;
}
.my {
  margin-bottom: 10px;
  width: 100%;

  .my-header {
    cursor: pointer;

    .icon {
      transform: rotate(180deg);
      transition: transform 150ms ease-out;
    }
  }

  .my-content {
    transition: all 150ms ease;
    max-height: 300px;
    overflow-x: hidden;
    overflow-y: auto;
  }
}

.my {
  background-color: #fff;
  box-shadow: 0 2px 3px lightgray;
  color: #4a4a4a;
  width: 100%;
}

.not-expanded {
  .my-header {
    .icon {
      transform: rotate(0deg);
    }

    max-height: 330px;
    overflow: auto;
  }

  .my-content {
    transform: scaleY(0);
    transform-origin: top;
    opacity: 0;
    height: 0;
    padding: 0;
  }
}

.my-header {
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  box-shadow: 0 1px 2px lightgray;
  display: flex;
  min-height: 40px;
}

.my-header-title {
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  color: #363636;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  font-weight: 700;

  align-items: center;
  margin: 0;
}

.my-header-icon {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  cursor: pointer;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: 40px;
  align-items: center;
  margin: 0;
}
.my-header-icon-remove {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  cursor: pointer;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: 20px;
  height: 100%;
  align-items: center;
  margin: 0;
}

.filter-trash {
  background: red;
  color: white;
  border-radius: 0 5px 5px 0;
}

content {
  max-height: 300px;
  overflow-y: auto;
}
</style>
